export class SoundManager {
    constructor() {
        this.enabled = false; // Вимкнено бо немає файлів звуків
        console.log('🔇 Звукові ефекти вимкнено (немає файлів)');
    }

    playActivate() {
        // Нічого не робимо - звуки вимкнені
    }

    playConnect() {
        // Нічого не робимо - звуки вимкнені
    }

    playError() {
        // Нічого не робимо - звуки вимкнені
    }

    play(audioElement) {
        // Нічого не робимо - звуки вимкнені
    }

    toggle() {
        this.enabled = !this.enabled;
        console.log(this.enabled ? '🔊 Звуки увімкнені' : '🔇 Звуки вимкнені');
        return this.enabled;
    }

    setEnabled(enabled) {
        this.enabled = enabled;
    }
}
